import React from 'react';
import EntityReviewsWithCommunityCard from 'sly/review/components/entity/EntityReviewsWithCommunityCard';
import { usePrefetch } from 'sly/services/api';

const ProviderReviewsSection = ({ partnerCollection }) => {
  const {
    requestInfo: { normalized: reviews },
  } = usePrefetch('getEntityReviews', {
    entityType: 'partner-collection',
    id: partnerCollection.id,
    'filter[value]': 'gt:3',
    sort: 'created_at',
    include:
      'searchResource,statusByUser,searchResource.gallery,searchResource.gallery.images',
  });

  if (!reviews?.length) return null;
  return (
    <div
      className='mt-6'
      data-tp-id='gen-div-1b1bb1c0-0559-43d7-9439-7540e0913e2b'
    >
      <h2
        className='font-t-l mb-6'
        data-tp-id='gen-h2-5baf3797-6848-4356-ab3f-190b58b6fcd1'
      >
        Recent Reviews about {partnerCollection?.name}
      </h2>
      <EntityReviewsWithCommunityCard reviews={reviews.slice(0, 5) || []} />
      <hr className='my-12' />
    </div>
  );
};

export default ProviderReviewsSection;
